import { render, staticRenderFns } from "./Gczp.vue?vue&type=template&id=3412f2ec&"
import script from "./Gczp.vue?vue&type=script&lang=js&"
export * from "./Gczp.vue?vue&type=script&lang=js&"
import style0 from "./Gczp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports